import { render, staticRenderFns } from "./sortPrice.vue?vue&type=template&id=223de66a&scoped=true"
import script from "./sortPrice.vue?vue&type=script&lang=js"
export * from "./sortPrice.vue?vue&type=script&lang=js"
import style0 from "./sortPrice.vue?vue&type=style&index=0&id=223de66a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223de66a",
  null
  
)

export default component.exports